export class FixedHeader {
  header;
  constructor() {}

  init() {
    this.header = document.querySelector('.header');
    this.changeFixed();

    window.addEventListener('scroll', () => {
      this.changeFixed();
    });
  }

  changeFixed() {
    if (window.scrollY > 30) {
      this.header.classList.add('fixed');
    } else {
      this.header.classList.remove('fixed');
    }
  }
}
